import { IStackStyles, IStackTokens, Icon, Stack } from "@fluentui/react";
import { CatalogCollectionTable } from "pages/Catalog2/Catalog.CollectionTable";
import { CSSProperties } from "react";
import {
  LinkWithParams,
  useNavigateWithParams,
} from "utils/components/LinkWithParams";
import { IStacCollection } from "types/stac";

interface LandingCollectionsProps {
  collections?: IStacCollection[];
}

const maxCollections = 8;

export const LandingCollections = ({ collections }: LandingCollectionsProps) => {
  const collectionCards = collections
    ?.sort((a, b) => {
      const dateA = new Date(a["msft:_created"]);
      const dateB = new Date(b["msft:_created"]);
      return dateB.getTime() - dateA.getTime();
    })
    .slice(0, maxCollections);

  const filteredFn = (collection: IStacCollection) => {
    return collectionCards?.includes(collection) || false;
  };

  const navigate = useNavigateWithParams();

  const handleButtonClick = () => {
    navigate("/collections/#create", { state: { panelOpen: true, mode: "create" } });
  };

  return (
    <Stack styles={containerStyles}>
      <div style={headerBarStyle}>
        <h2 style={headerStyle}>Recent collections</h2>
      </div>
      {collections && (
        <CatalogCollectionTable
          preFilterCollectionFn={filteredFn}
          setFilterText={() => {}}
          filterText={""}
          isEditable={false}
          handleNoResultCreateButton={handleButtonClick}
        />
      )}
      {collections && (
        <LinkWithParams style={linkStyle} to="/collections">
          <Stack
            horizontal
            verticalAlign="center"
            horizontalAlign="space-between"
            tokens={linkTokens}
            styles={containerStyles}
          >
            <span>View all</span>
            <Icon iconName="ChromeBackMirrored" />
          </Stack>
        </LinkWithParams>
      )}
    </Stack>
  );
};

const linkTokens: IStackTokens = {
  childrenGap: 5,
};

const containerStyles: IStackStyles = {
  root: {
    marginTop: 40,
    marginLeft: 36,
    marginRight: 36,
  },
};

const headerBarStyle: CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const headerStyle: CSSProperties = {
  textAlign: "center",
  margin: "0 auto 0 5px",
  fontSize: 22,
};

const linkStyle: CSSProperties = {
  marginRight: 20,
  textDecorationLine: "none",
  display: "flex",
  justifyContent: "flex-end",
};
